"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bundleId = void 0;
var _uniqueId = require("./unique-id");
/**
 * @file Contains a unique identifier for the running agent bundle
 * when loaded.
 * @copyright 2023 New Relic Corporation. All rights reserved.
 * @license Apache-2.0
 */

/**
 * Provides a unique id for the current agent bundle
 */
const bundleId = exports.bundleId = (0, _uniqueId.generateUuid)();